import React, { Component } from 'react'
import { Text, View, StyleSheet, Dimensions, Platform, Animated, Easing, TouchableOpacity } from 'react-native';
import { JDText, JDImage, JDTouchable, JDDevice, JDTouchableWithoutFeedback } from '@jdreact/jdreact-core-lib'
import PropTypes from 'prop-types'
import Swiper from '../../../../components/thirdScript/RNSwiper';
import VrLogo from '../../../../components/vrLogo';
import WebSwiper from './WebSwiper'
import appStyles from '../../../../App.style';
import { pt, isWeb , sendClickDataWithJsonParam, sendExposureData } from '../../../../components/utiles'
import VideoPlayer from './videoPlayer';
import { isWebAndroid } from '../../../../utils/ut.web.js'
import vr_img_static from '../../../../components/vrLogo/img/8.png'
import topBg from '../../../../images/detail/top-bg.png'

const { width } = Dimensions.get('window');
const swiperHeight = JDDevice.getRpx(560);

const renderPagination = (index, total, context) => {
	if (total > 1) {
		return (
			<View style={[styles.indicator, appStyles.flexCenter, styles.videoHidPagination]}>
				<JDText style={styles.indicatorText}>{`${index + 1}/${total}`}</JDText>
			</View>
		);
	} else {
		return null;
	}
};

export default class ImgSwiper extends Component {
	static propTypes = {
		imgSwiperData: PropTypes.array,
		previewAble: PropTypes.bool,
		cityId: PropTypes.number,
		isVR: PropTypes.bool,
		showVR: PropTypes.bool,
		changeState: PropTypes.func,
		isVideo: PropTypes.bool,
		surfacePlot: PropTypes.string,
		playUrl: PropTypes.string,
		activeHouseType: PropTypes.bool,
	};
	constructor(props) {
		super(props);
		this.state = {
			currentPage: 0,
			offset: new Animated.Value(0),
			vrLogo: new Animated.Value(0),
			hasTab: false,
			activeVr: false,
			activeVideo: false,
			activeHouseType: false,
			videoIndex: null,
		};
		this.swiperRef = null

		this.mainImgAnimated = Animated.timing(
			this.state.offset,
			{
				toValue: 2,
				duration: 3000,
				easing: Easing.in
			}
		);
	}

	_renderPage = (imgUrl, index, isVR) => {
		if (isVR && this.props.showVR && index === 0) {
			const imgPosition = this.state.offset.interpolate({
				inputRange: [0, 1, 2],
				outputRange: [pt(-50), pt(50), pt(-50)]
			});
			return (
				<JDTouchableWithoutFeedback
					style={styles.slide}
					onCaptureTouchThreshold={15}
					key={"swiper_" + index}
					onPress={() => {
						this._clickHouseImg(index);
					}}
				>
					<View style={styles.vr_img_con}>
						{Platform.OS === 'ios' ? <VrLogo _onPress={() => this._clickHouseImg(index)}></VrLogo> : <JDImage style={styles.vr_img_static} source={vr_img_static}></JDImage>}
					</View>
					<Animated.View
						style={{
							transform: [{ translateX: imgPosition }]
						}}
						>
						<JDImage style={styles.image_first} source={{ uri: imgUrl }}></JDImage>
					</Animated.View>
				</JDTouchableWithoutFeedback>
			)
		}
		if (this.props.isVideo && index === this.state.videoIndex) {
			const { surfacePlot, playUrl } = this.props;
			return (
				// <View>
				<VideoPlayer ref={(_) => { this.videoPlayer = _ }} surfacePlot={surfacePlot} playUrl={playUrl} />
				// </View>
			)
		}
		return (
			<JDTouchableWithoutFeedback
				style={styles.slide}
				onCaptureTouchThreshold={15}
				key={"swiper_" + index}
				onPress={() => {
					this._clickHouseImg(index);
				}}
			>
				<JDImage style={styles.image} source={{ uri: imgUrl }}></JDImage>
			</JDTouchableWithoutFeedback>
		)
	};
	controlPause = () => {
		this.swiperRef.outControlPause && this.swiperRef.outControlPause();
		this.videoPlayer && this.videoPlayer.outControlPause && this.videoPlayer.outControlPause();
		styles.videoHidPagination = {};
	}
	controlPlay = () => {
		const { pageId, skuId, playUrl } = this.props;
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_Video',
			page_id: pageId,
			json_param: {
				skuid: skuId,
				video_url: playUrl
			},
		})
		// 安卓机型需切换视频播放，兼容确实播放按钮问题
		isWebAndroid() && this.swiperRef.outControlPlay && this.swiperRef.outControlPlay();
		// this.videoPlayer && this.videoPlayer.outControlPlay && this.videoPlayer.outControlPlay();
		// 兼容安卓机隐藏元素时不能使用absoulte
		styles.videoHidPagination = { display: 'none', position: 'relative', };
	}
	_pageChange = (pageNumber) => {
		const { isVR, isVideo, imgSwiperData, isHouseTypeLength } = this.props;
		const typeIndexStart = imgSwiperData.length - isHouseTypeLength - 1;
		this.setState({
			currentPage: pageNumber
		});
		if (isVR && isVideo) {
			if (pageNumber === 0) {
				this.setState({ activeVr: true, activeVideo: false, activeHouseType: false })
				// TODO: 联调时播放逻辑根据当前是否是视频逻辑优化
				this.controlPause();
			} else if (pageNumber === 1) {
				this.setState({ activeVideo: true, activeVr: false, activeHouseType: false })
				this.controlPlay();
			} else if (isHouseTypeLength > 0 && pageNumber > typeIndexStart) {
				this.setState({ activeVideo: false, activeVr: false, activeHouseType: true });
				this.controlPause();
			} else {
				this.setState({ activeVideo: false, activeVr: false, activeHouseType: false });
				this.controlPause();
			}
		} else if (!isVR && !isVideo) {
			if (isHouseTypeLength > 0 && pageNumber > typeIndexStart) {
				this.setState({ activeVideo: false, activeVr: false, activeHouseType: true });
				this.controlPause();
			} else {
				this.setState({ activeVideo: false, activeVr: false, activeHouseType: false });
				this.controlPause();
			}
		} else {
			if (pageNumber === 0) {
				this.setState({ activeVideo: true, activeVr: true, activeHouseType: false })
				this.controlPlay();
			} else if (isHouseTypeLength > 0 && pageNumber > typeIndexStart) {
				this.setState({ activeVideo: false, activeVr: false, activeHouseType: true });
				this.controlPause();
			} else {
				this.setState({ activeVideo: false, activeVr: false, activeHouseType: false });
				this.controlPause();
			}
		}
		const { pageId, skuId } = this.props;
		sendExposureData({
			event_id: 'OfficeBuilding_HouseDetail_Picture_expo',
			page_id: pageId,
			json_param: {
				skuid: skuId,
				picture_sort: pageNumber + '',
				picurl: imgSwiperData[pageNumber]
			},
		})

	};
	_clickHouseImg = (index) => {
		if (!this.props.previewAble) {
			return
		}
		this.props.enterImgPreview(index);

	};

	// H5 Vr切换轮播
	vrBtnClick = () => {
		const { imgSwiperData, pageId, skuId } = this.props;
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_VRTab',
			page_id: pageId,
			json_param: {
				skuid: skuId
			},
		})
		if (imgSwiperData && imgSwiperData.length > 1) {
			this.swiperRef.state.swiperRef.slideTo(0);
		}
	}
	// H5 切换视频轮播
	videoBtnClick = () => {
		const { pageId, skuId, isVR } = this.props;
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_VideoTab',
			page_id: pageId,
			json_param: {
				skuid: skuId
			},
		})
		if (isVR) {
			this.swiperRef.state.swiperRef.slideTo(1);
		} else {
			this.swiperRef.state.swiperRef.slideTo(0);
		}
	}
	// H5 切换照片轮播
	picBtnClick = () => {
		const { pageId, skuId, isVR, isVideo } = this.props;
		const { currentPage, activeHouseType } = this.state;
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_PictureTab',
			page_id: pageId,
			json_param: {
				skuid: skuId
			},
		})
		if (isVR && isVideo) {
			if (currentPage < 2 || activeHouseType) {
				this.swiperRef.state.swiperRef.slideTo(2);
			}
		} else if (isVideo || isVR) {
			if (currentPage === 0 || activeHouseType) {
				this.swiperRef.state.swiperRef.slideTo(1);
			}
		} else {
			if (activeHouseType) {
				this.swiperRef.state.swiperRef.slideTo(0);
			}
		}
	}
	houseTypeBtnClick = () => {
		const { imgSwiperData, isHouseTypeLength } = this.props;
		const { activeHouseType } = this.state;
		if (!activeHouseType) {
			const typeIndexStart = imgSwiperData.length - isHouseTypeLength
			this.swiperRef.state.swiperRef.slideTo(typeIndexStart);
		}
	}
	//点击切换到Vr轮播位置
	rn_vrBtnClick = () => {
		const { currentPage } = this.state;
		const { pageId, skuId } = this.props;
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_VRTab',
			page_id: pageId,
			json_param: {
				skuid: skuId
			},
		})
		if (currentPage === 0) {
			return;
		} else {
			this.swiperRef.scrollBy(Platform.OS === 'ios'? 0 - currentPage: 0);
		}
	}

	// 点击切换视频轮播位置
	rn_videoBtnClick = () => {
		const { pageId, skuId, isVR } = this.props;
		const { currentPage } = this.state;
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_VideoTab',
			page_id: pageId,
			json_param: {
				skuid: skuId
			},
		})

		if (isVR) {
			if (currentPage === 0) {
				this.swiperRef.scrollBy(1)
			} else if (currentPage === 1) {
				return;
			} else {
				this.swiperRef.scrollBy(Platform.OS === 'ios'? 1 - currentPage: 1)
			}
		} else {
			this.swiperRef.scrollBy(Platform.OS === 'ios'? 0 - currentPage: 0);
		}
	}

	// 点击切换到图片位置
	rn_picBtnClick = () => {
		const { currentPage, activeHouseType } = this.state;
		const { pageId, skuId, isVR, isVideo } = this.props;
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_PictureTab',
			page_id: pageId,
			json_param: {
				skuid: skuId
			},
		})
		if (isVR && isVideo) {
			if (currentPage < 2) {
				this.swiperRef.scrollBy(2);
			} else if (activeHouseType) {
				this.swiperRef.scrollBy(Platform.OS === 'ios'? 2 - currentPage: 2);
			}
		} else if (isVideo || isVR) {
			if (currentPage < 1) {
				this.swiperRef.scrollBy(1);
			} else if (activeHouseType) {
				this.swiperRef.scrollBy(Platform.OS === 'ios'? 1 - currentPage: 1);
			}
		} else {
			if (activeHouseType) {
				this.swiperRef.scrollBy(0);
			}
		}
	}
	// 户型
	rn_houseTypeBtnClick = () => {
		const { imgSwiperData, isHouseTypeLength } = this.props;
		const { activeHouseType } = this.state;
		if (!activeHouseType) {
			const typeIndexStart = imgSwiperData.length - isHouseTypeLength
			this.swiperRef.scrollBy(typeIndexStart);
		}
	}
	_positionAnimated() {
		this.state.offset.setValue(0);
		this.mainImgAnimated.start(() => this._positionAnimated());
	}

	componentDidMount() {
		const { isVR, isVideo, isHouseTypeLength } = this.props;
		// 存在vr或video时展示tab栏
		if (isVR || isVideo || isHouseTypeLength > 0) {
			this.setState({
				hasTab: true
			})
		}
		this._positionAnimated()
		this._pageChange(0)
		if (isVR && isVideo) {
			this.setState({ videoIndex: 1 })
		} else if (isVideo) {
			this.setState({ videoIndex: 0 })
		} else {
			return;
		}

	}

	render() {
		const { imgSwiperData, isVR, showVR, isVideo, surfacePlot, playUrl, isHouseTypeLength, skuId, pageId } = this.props;
		const { currentPage, hasTab, activeVr, activeVideo, activeHouseType } = this.state;
		if (Platform.OS == 'android' || Platform.OS == 'ios') {
			return (
				<View style={styles.detailBannerBox}>
					<Swiper
						ref={_ => this.swiperRef = _}
						height={swiperHeight}
						activeDot={null}
						style={styles.bannerWrapper}
						renderPagination={renderPagination}
						loop={false}
						onIndexChanged={this._pageChange}
						bounces={true}
					>
						{
							imgSwiperData.map((item, index) => {
								return (
									this._renderPage(item, index, isVR)
								)
							})
						}
					</Swiper>
					<View style={styles.bgWrapper}>
						<JDImage style={styles.bgImg} source={topBg}></JDImage>
					</View>
					{
						imgSwiperData
						&& imgSwiperData.length > 1
						&& hasTab
						&& <View style={styles.swiperLabelWrap}>
							<View style={styles.labelContainer}>
								{
									isVR && <TouchableOpacity style={styles.label} onPress={() => this.rn_vrBtnClick()}>
										<View style={[activeVr ? styles.activeB : '']}>
											<JDText style={[styles.labelText, activeVr && styles.actived]}>VR</JDText></View>
									</TouchableOpacity>

								}
								{
									isVideo && <TouchableOpacity style={styles.label} onPress={() => this.rn_videoBtnClick()}>
										<View style={[activeVideo ? styles.activeB : '']}>
											<JDText style={[styles.labelText, activeVideo && styles.actived]}>视频</JDText></View>
									</TouchableOpacity>
								}
								<TouchableOpacity style={styles.label} onPress={() => this.rn_picBtnClick()}>
									<View style={[(!activeVr && !activeVideo && !activeHouseType) ? styles.activeB : '']}>
										<JDText style={[styles.labelText, !activeVr && !activeVideo && !activeHouseType && styles.actived]}>图片</JDText>
									</View>
								</TouchableOpacity>
								{
									isHouseTypeLength > 0 && <TouchableOpacity style={styles.label} onPress={() => this.rn_houseTypeBtnClick()}>
										<View style={[activeHouseType ? styles.activeB : '']}>
											<JDText style={[styles.labelText, activeHouseType && styles.actived]}>户型</JDText></View>
									</TouchableOpacity>
								}
							</View>
						</View>
					}
				</View>
			);
		} else {
			return (
				<View style={styles.detailBannerBox}>
					<WebSwiper
						ref={ref => this.swiperRef = ref}
						imgSwiperData={imgSwiperData}
						imgWrapperWebStyle={styles.imgWrapperWebStyle}
						imgWebStyle={styles.imgWebStyle}
						indicatorWebStyle={{ ...styles.indicator, ...styles.indicatorWeb }}
						toClickHouseImg={this._clickHouseImg}
						onIndexChanged={this._pageChange}
						isVR={isVR}
						isVideo={isVideo}
						showVR={showVR}
						activeVideo={activeVideo}
						surfacePlot={surfacePlot}
						playUrl={playUrl}
						skuId={skuId}
						pageId={pageId}

					></WebSwiper>
					<View style={styles.bgWrapper}>
						<JDImage style={styles.bgImg} source={topBg}></JDImage>
					</View>
					{
						imgSwiperData
						&& imgSwiperData.length > 1
						&& hasTab
						&& <View style={styles.swiperLabelWrap}>
							<View style={styles.labelContainer}>
								{
									isVR && <JDTouchable style={styles.label_h5} onPress={() => this.vrBtnClick()}>
										<View style={[activeVr ? styles.activeB : '']}>
											<Text style={[styles.labelText, activeVr && styles.actived]}>VR</Text>
										</View>
									</JDTouchable>
								}
								{
									isVideo && <JDTouchable style={styles.label_h5} onPress={() => this.videoBtnClick()}>
										<View style={[activeVideo ? styles.activeB : '']}>
											<Text style={[styles.labelText, activeVideo && styles.actived]}>视频</Text>
										</View>
									</JDTouchable>
								}
								<JDTouchable style={styles.label_h5} onPress={() => this.picBtnClick()}>
									<View style={[(!activeVr && !activeVideo && !activeHouseType) ? styles.activeB : '']}>
										<Text style={[styles.labelText, !activeVideo && !activeVr && !activeHouseType && styles.actived]}>图片</Text></View>
								</JDTouchable>
								{
									isHouseTypeLength > 0 && <JDTouchable style={styles.label_h5} onPress={() => this.houseTypeBtnClick()}>
										<View style={[activeHouseType ? styles.activeB : '']}>
											<Text style={[styles.labelText, activeHouseType && styles.actived]}>户型</Text>
										</View>
									</JDTouchable>
								}
							</View>
						</View>
					}
				</View>
			)
		}

	}
}

const styles = StyleSheet.create({
	detailBannerBox: {
		backgroundColor: 'transparent',
		position: 'relative',
		// alignItems: 'center',
	},
	bannerWrapper: {
		height: JDDevice.getRpx(560),
		position: 'relative'
	},
	slide: {
		width,
		height: JDDevice.getRpx(560),
		justifyContent: 'center',
		backgroundColor: 'transparent',
		position: 'relative'
	},
	image: {
		width,
		height: JDDevice.getRpx(560),
		// resizeMode: 'stretch',
		backgroundColor: '#f4f4f4'
	},
	image_first: {
		width: width + pt(+ 100),
		marginLeft: -pt(50),
		height: JDDevice.getRpx(560),
		backgroundColor: '#f4f4f4'
	},
	indicator: {
		position: 'absolute',
		backgroundColor: 'rgba(0,0,0,.5)',
		right: JDDevice.getRpx(20),
		bottom: JDDevice.getRpx(90),
		width: JDDevice.getRpx(100),
		height: JDDevice.getRpx(42),
		flexDirection: 'row',
		borderRadius: JDDevice.getRpx(30),
	},
	videoHidPagination: {
		// display: 'none',
		// position: 'relative',
		// backgroundColor: 'pink'
	},
	indicatorText: {
		color: '#fff'
	},
	// web端轮播图的样式
	imgWrapperWebStyle: {
		width: width,
		height: JDDevice.getRpx(560),
		backgroundColor: '#f4f4f4'
	},
	swiperLabelWrap: {
		width: '100%',
		position: 'absolute',
		bottom: 0,
		alignItems: 'center',
		zIndex:999
	},
	imgWebStyle: {
		width,
		height: JDDevice.getRpx(560),
		resizeMode: 'contain',
		backgroundColor: '#f4f4f4'
	},
	indicatorWeb: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		left: JDDevice.getRpx(620),
		color: '#fff'
	},
	labelContainer: {
		position: 'absolute',
		bottom: pt(108),
		// left: pt(280),
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		// width: pt(200),
		height: pt(48),
		backgroundColor: 'rgba(0,0,0,0.7)',
		zIndex: 3,
		borderRadius: pt(25)
	},
	label: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: pt(100),
		height: pt(48),
		borderRadius: pt(25),
		overflow: 'hidden',
		lineHeight: pt(48),
		textAlign: 'center',
		color: '#000'
	},
	label_h5: {
		width: pt(100),
		height: pt(48),
		lineHeight: pt(48),
		textAlign: 'center',
		color: '#ffffff'
	},
	actived: {
		color: '#000'
	},
	linearStyle: {
		height: pt(48),
		width: pt(100),
		borderRadius: pt(25),
		// transform: 'inherit',
		top: 'auto'
	},
	labelText: {
		fontSize: pt(24),
		height: pt(48),
		lineHeight: pt(48),
		zIndex: 5,
		color: '#ffffff',
		textAlign: 'center'
	},
	// vrContainer: {
	// 	width: pt(120),
	// 	height: pt(120),
	// },
	vr_img_con: {
		position: 'absolute',
		top: pt(178),	// 垂直居中
		left: pt((750 - 120) / 2),
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		width: pt(120),
		height: pt(120),
		zIndex: 5
	},
	vr_img: {
		width: pt(1680),
		height: pt(120),
		position: 'absolute',
		top: 0,
		left: 0
	},
	vr_img_static: {
		width: pt(120),
		height: pt(120)
	},
	activeB: {
		backgroundColor: '#ffffff',
		borderRadius: pt(25),
		width: pt(100),
	},
	bgWrapper: {
		position: 'absolute',
		bottom: 0,
		width: '100%',
		left: 0,
		zIndex: 7,
		height: JDDevice.getRpx(60),
	},
	bgImg: {
		width: '100%',
		height: pt(60)
	}
});
